import { render, staticRenderFns } from "./doctor_taskForm.vue?vue&type=template&id=3f849073&scoped=true&"
import script from "./doctor_taskForm.vue?vue&type=script&lang=js&"
export * from "./doctor_taskForm.vue?vue&type=script&lang=js&"
import style0 from "./doctor_taskForm.vue?vue&type=style&index=0&id=3f849073&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f849073",
  null
  
)

export default component.exports